"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAsync = exports.forEachAsync = exports.everyAsync = exports.someAsync = void 0;
async function someAsync(target, condition) {
    for (let i = 0; i < target.length; ++i) {
        const ok = await condition(target[i], i, target);
        if (ok) {
            return true;
        }
    }
    return false;
}
exports.someAsync = someAsync;
async function everyAsync(target, condition) {
    for (let i = 0; i < target.length; ++i) {
        const ok = await condition(target[i], i, target);
        if (!ok) {
            return false;
        }
    }
    return true;
}
exports.everyAsync = everyAsync;
async function forEachAsync(target, cb) {
    for (let i = 0; i < target.length; ++i) {
        await cb(target[i], i, target);
    }
}
exports.forEachAsync = forEachAsync;
async function mapAsync(target, cb) {
    const results = [];
    for (let i = 0; i < target.length; ++i) {
        const r = await cb(target[i], i, target);
        results.push(r);
    }
    return results;
}
exports.mapAsync = mapAsync;
//# sourceMappingURL=arrays.js.map